import axiosClient from "../../../../api/apiClient";

export const APITestSaveLogs = (data: object) => {
    return axiosClient.post(`/tests/saveLog`, data);
};

export const APITestLogs = (data: object) => {
    return axiosClient.post(`/tests/logs`, data);
};

export const APITestGenerateLogs = (data: object) => {
    return axiosClient.post(`tests/logs/report`, data);
};